﻿import { date } from "quasar"
import { localization } from "@/plugins/i18n"
import type { Locale, TranslateOptions } from 'vue-i18n'

const re = new RegExp( '($|;| |\\(|\\n)([aiousvkz]) ', 'ig' )

export enum DateFormat {
    EventFrom,
    EventTo,
    Short,
    DateTimeLong,
    DateTimeCommon,
    DateTimeHuman,
    System,
    SystemDate,
    Time
}

interface DateFormatStrings {
    [ DateFormat ]: string
}

const dateFormatMasks: { [ key: string ]: DateFormatStrings } = {
    cs: {
        [ DateFormat.EventFrom ]: 'D. M.',
        [ DateFormat.EventTo ]: 'D. M. YYYY',
        [ DateFormat.Short ]: 'DD. MM. YYYY',
        [ DateFormat.DateTimeLong ]: 'DD. MM. YYYY HH:mm:ss',
        [ DateFormat.DateTimeCommon ]: 'DD. M. YYYY H:mm',
        [ DateFormat.DateTimeHuman ]: 'D. M. YYYY H:mm',
        [ DateFormat.System ]: 'YYYY-MM-DD[T]HH:mm:ssZ',
        [ DateFormat.SystemDate ]: 'YYYY-MM-DD',
        [ DateFormat.Time ]: 'HH:mm:ss'
    },
    en: {
        [ DateFormat.EventFrom ]: 'MM/DD',
        [ DateFormat.EventTo ]: 'MM/DD/YYYY',
        [ DateFormat.Short ]: 'MM/DD/YYYY',
        [ DateFormat.DateTimeLong ]: 'MM/DD/YYYY HH:mm:ss',
        [ DateFormat.DateTimeCommon ]: 'MM/DD/YYYY HH:mm',
        [ DateFormat.DateTimeHuman ]: 'MM/DD/YYYY HH:mm',
        [ DateFormat.System ]: 'YYYY-MM-DD[T]HH:mm:ssZ',
        [ DateFormat.SystemDate ]: 'YYYY-MM-DD',
        [ DateFormat.Time ]: 'HH:mm:ss'
    }
}

export function ts ( msg: string, list = {}, options: TranslateOptions = {} ): string {
    // We want to intercept non-breaking space after one-letter prepositions in Czech language

    return localization.global.t( msg, list, options ).replaceAll( re, '$1$2\xa0' )
}

export function ds ( d: Date | number | null, format: DateFormat, ignoreDate: boolean = false, locale?: Locale ): string {
    if ( d === null || d === undefined )
        return ''

    const masks = dateFormatMasks[ locale ?? localization.global.locale.value ]
    if ( !masks )
        return ''

    const mask = masks[ format ]
    if ( !mask )
        return ''

    if ( ignoreDate && typeof d === 'number' ) {
        const hours = Math.floor( d / 3600 )
        const minutes = Math.floor( ( d % 3600 ) / 60 )
        const seconds = Math.floor( d % 60 )

        return mask
            .replace( 'HH', String( hours ).padStart( 2, '0' ) )
            .replace( 'mm', String( minutes ).padStart( 2, '0' ) )
            .replace( 'ss', String( seconds ).padStart( 2, '0' ) )
            .replace( 'H', String( hours ) )
            .replace( 'm', String( minutes ) )
            .replace( 's', String( seconds ) )
    }

    return date.formatDate( new Date( d ), mask )
}

export function tcs ( msg: string, num: number, options: TranslateOptions = {} ): string {
    return localization.global.t( msg, { n: num }, options ).replaceAll( / /g, '\xa0' )
}

export function ns ( n: number, format: string | undefined = undefined, locale?: Locale ): string {
    return localization.global.n( n, format, locale ?? localization.global.locale.value )
}
